<template>
    <div>
        <el-dialog
                title="Изменение информации о доставке"
                :visible.sync="$store.getters.showOrderDeliveryInfoDialog"
                width="60%"
                :before-close="handleClose"
        >
            <el-form id="uploadForm" name="uploadForm" label-width="30%" label-position="left"
                     enctype="multipart/form-data"
                     v-loading="isLoad">
                <el-form-item label="Тип доставки">
                    <el-select v-model="query.delivery_type" placeholder="Тип доставки">
                        <el-option
                            v-for="(item, index) in deliveryTypeConfig"
                            :key="index"
                            :value="item.options"
                            :label="item.title"/>
                    </el-select>
                </el-form-item>
               
                <el-form-item label-width="0" v-if="query.delivery_type !== deliveryTypeRoot.pickup.value">

                     <el-form-item 
                     v-if="query.delivery_type === deliveryTypeRoot.delivery.value"
                     label="Населенный пункт">
                        <el-select v-model="query.region_id" placeholder="Выберите населенный пункт">
                            <el-option
                                v-for="(item, index) in regions"
                                :key="index"
                                :value="item.id"
                                :label="item.name"/>
                        </el-select>
                    </el-form-item>

                    <el-form-item 
                     label="Стоимость доставки">
                        <el-col :span="18">
                            <el-input v-model="query.price"></el-input>
                        </el-col>
                    </el-form-item>

                    <el-form-item 
                     v-if="query.delivery_type === deliveryTypeRoot.deliveryTC.value"
                     label="Транспортная компания">
                        <el-select v-model="query.transport_company_id" placeholder="Выберите транспортную компанию">
                            <el-option
                                v-for="(item, index) in transportCompanies"
                                :key="index"
                                :value="item.id"
                                :label="item.name"/>
                        </el-select>
                    </el-form-item>

                    <el-form-item 
                    v-if="query.delivery_type === deliveryTypeRoot.deliveryTC.value"
                    label="Населенный пункт">
                        <el-col :span="18">
                            <el-input v-model="query.city"></el-input>
                        </el-col>
                        <el-col :span="2">
                            <i v-if="keys.indexOf('delivery_info.address.city') !== -1"
                               class="el-icon-warning error"/>
                        </el-col>
                    </el-form-item>

                    <el-form-item label="Улица" >
                        <el-col :span="18">
                            <el-input v-model="query.street"></el-input>
                        </el-col>
                        <el-col :span="2">
                            <i v-if="keys.indexOf('delivery_info.address.street') !== -1"
                               class="el-icon-warning error"/>
                        </el-col>
                    </el-form-item>

                    <el-form-item label="Дом" >
                        <el-col :span="18">
                            <el-input v-model="query.house"></el-input>
                        </el-col>
                        <el-col :span="2">
                            <i v-if="keys.indexOf('delivery_info.address.house') !== -1"
                               class="el-icon-warning error"/>
                        </el-col>
                    </el-form-item>

                    <el-form-item label="Подъезд" >
                        <el-col :span="18">
                            <el-input v-model="query.porch"></el-input>
                        </el-col>
                        <el-col :span="2">
                            <i v-if="keys.indexOf('delivery_info.address.porch') !== -1"
                               class="el-icon-warning error"/>
                        </el-col>
                    </el-form-item>


                    <el-form-item label="Этаж" >
                        <el-col :span="18">
                            <el-input v-model="query.floor"></el-input>
                        </el-col>
                        <el-col :span="2">
                            <i v-if="keys.indexOf('delivery_info.address.floor') !== -1"
                               class="el-icon-warning error"/>
                        </el-col>
                    </el-form-item>

                    <el-form-item label="Квартира" >
                        <el-col :span="18">
                            <el-input v-model="query.apartment"></el-input>
                        </el-col>
                        <el-col :span="6">
                            <i v-if="keys.indexOf('delivery_info.address.apartment') !== -1"
                               class="el-icon-warning error"/>
                        </el-col>
                    </el-form-item>

                    <el-form-item label="До двери?" >
                        <el-checkbox v-model="query.to_the_door"></el-checkbox>
                    </el-form-item>

                    <el-form-item v-if="query.to_the_door === true" label="Тип подъема" >
                        <el-select v-model="query.to_the_door_climb" placeholder="Выберите тип подъема">
                            <el-option :value="climbType.elevator.value" :label="climbType.elevator.title"></el-option>
                            <el-option :value="climbType.stairs.value" :label="climbType.stairs.title"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="Дата доставки" >
                    <el-col :span="18">
                        <el-date-picker
                            type="date"
                            placeholder="Выберите день"
                            v-model="datePicker"
                            :picker-options="pickerDateOptions"
                            @change="onChangeDate"
                        />
                    </el-col>
                    <el-col :span="2" class="ml-5">
                        <i v-if="keys.indexOf('delivery_info.date') !== -1" class="el-icon-warning error"/>
                    </el-col>
                    </el-form-item>
                    <el-form-item label="Время доставки" >                        
                        <el-row>
                            <el-col>
                                <el-select
                                :disabled="isDasableTimePicker"
                                v-model="query.interval"
                                clearable
                                placeholder="Время доставки">
                                    <el-option
                                        v-for="item in getSelectInterval"
                                        :key="item.id"
                                        :value="item.id"
                                        :label="item.time"/>
                                </el-select>
                            </el-col>
                            <el-col :span="1">
                                <i v-if="keys.indexOf('delivery_info.interval') !== -1" class="el-icon-warning error"/>
                            </el-col>
                        </el-row>
                    </el-form-item>

                </el-form-item>
                <el-form-item  v-else label-width="0">
                    <el-form-item label="Дата самовывоза">
                        <el-col :span="18">
                            <el-date-picker
                            type="date"
                            placeholder="Выберите день"
                            v-model="datePicker"
                            :picker-options="pickerDateOptions"
                            @change="onChangeDate"
                        />
                            <!-- <el-input type="date" v-model="query.pickup_date"></el-input> -->
                        </el-col>
                        <el-col :span="2">
                            <i v-if="keys.indexOf('delivery_info.date') !== -1" class="el-icon-warning error"/>
                        </el-col>
                    </el-form-item>
                </el-form-item>
            </el-form>
            <el-button @click="handleClose">Отмена</el-button>
            <el-button @click="saveDeliveryInfoOrder">Сохранить</el-button>
        </el-dialog>
    </div>

</template>

<script>

import axios from "axios";
import deliveryTypeConfig from '../../../composable/config/devlivery-type.config'
import deliveryTypeRoot from '../../../composable/type/delivery.type'
import climbType from '../../../composable/type/climb.type'
import orderDelivaryRequestConfig from '../../../composable/config/order-delivery-recuest.config'
import orderDelivaryTCRequestConfig from '../../../composable/config/order-delivery-tc-recuest.config'
import orderPickupRequestConfig from '../../../composable/config/order-pickup-request.config'
import useFormRequest from '../../../composable/useFormRequest'

export default {
    props: ['orderId', 'deliveryType1', 'deliveryInfo1', 'regions', 'pickupDate', 'transportCompanies'],
    data: function () {
        return {
            deliveryTypeConfig,
            deliveryTypeRoot,
            climbType,            
            query: {
                delivery_type: deliveryTypeRoot.default.value,
                interval: '',
                date: '',
                city: '',
                price: 0,
                to_the_door: false,
                to_the_door_climb: climbType.default.value,
                transport_company_id: '',
                region_id: 0,
                street: '',
                house: '',
                porch: '',
                floor: '',
                apartment: 0,
                pickup_date: '',
            },
            val: '',
            datePicker: '',
            keys: [],
            pickerDateOptions: {
                disabledDate: this.handleDisableDate
            },
            availDates: [],
            selecIntervals: [],
            isLoad: false,
        }
    },

    computed: {
        getSelectInterval() {
            if (this.datePicker && this.datePicker !== '') {
                const humanDate = this.getHumanDate(this.datePicker)
                const interavals = this.getSelectableIntervals(humanDate)
                return interavals
            }
            return []
        },
        
        isDasableTimePicker() {
            return !this.datePicker || this.datePicker === ''
        }
    },
    mounted() {
        this.unsubscribe = this.$store.subscribe((mutation) => {
          if (mutation.type === 'showOrderDeliveryInfoDialog' && mutation.payload) {
            this.initializePropsQuery()
          }
        })
        this.getIntervalsData()
    },
    methods: {

        converToRequestForm(value) {
            if (!value) return undefined
            const { convertToRequestProps, setConfig } = useFormRequest();            
            setConfig(this.getConfig(this.query.delivery_type))
            const result = convertToRequestProps(value)
            return result
        },

        saveDeliveryInfoOrder() {
            const query = this.converToRequestForm(this.query)
            this.isLoad = true
            axios.post('/order/' + this.orderId + '/delivery', query).then(() => {
                    this.handleClose()
                    this.$emit('updateParent');
                }
            ).catch((errors) => {
                if (errors.response.status === 401) {
                    this.handleClose()
                    this.$router.push('/login');
                }
                if (errors.response.status === 422) {
                    this.$notify.error('Не корректно заполнены поля')
                    this.keys = Object.keys(errors.response.data.errors);
                } else if (errors.response?.data?.message) {
                    this.$notify.error({
                        message: errors.response.data.message
                        })
                }

            })
            .finally(()=> this.isLoad = false);
        },
        handleClose() {
            this.keys = [];
            this.$store.commit('showOrderDeliveryInfoDialog', false);
        },

        handleDisableDate(v) {
            const findResult = this.availDates.findIndex((e) => {
                const date = new Date(e.date)
                return date.getMonth() === v?.getMonth() && date.getDate() === v?.getDate()
            })
            return !(findResult >= 0)
        },

        getConfig(type){
            if (type === this.deliveryTypeRoot.delivery.value) {
                return orderDelivaryRequestConfig;
            }
            if (type === this.deliveryTypeRoot.pickup.value) {
                return orderPickupRequestConfig;
            }
            if (type === this.deliveryTypeRoot.deliveryTC.value) {
                return orderDelivaryTCRequestConfig;
            }
        },

        getIntervalsData() {
            axios.get('order/delivery-intervals')
            .then((response) => this.availDates = response.data)

        },

        getSelectableIntervals(humanDate) {
            const findResult = this.availDates.find((e) => e.date === humanDate)
            if (findResult) {
                const selectMap = findResult.intervals
                return selectMap
            }
            return []
        },

        getHumanDate(value){
            const date = new Date(value)
            if (date) {
                const  options = { year: 'numeric', month: '2-digit', day: '2-digit' };
                let result = date.toLocaleDateString('ru', options)
                result = result.split('.').reverse().join('-')
                return result 
            }
            return ''
        },      

        initializePropsQuery() {
            this.query.delivery_type = this?.deliveryType1 || deliveryTypeRoot.default.value;
            this.query.pickup_date = this?.deliveryInfo1?.date || '';
            this.query.date = this?.deliveryInfo1?.date || '';
            this.query.interval = this?.deliveryInfo1?.time || '';
            this.query.price = this?.deliveryInfo1?.price || 0;
            this.query.to_the_door = this?.deliveryInfo?.to_the_door || false;
            this.query.to_the_door_climb = this?.deliveryInfo?.to_the_door_climb || climbType.default.value;
            this.query.street = this?.deliveryInfo1?.address?.street || '';
            this.query.house = this?.deliveryInfo1?.address?.house || '';
            this.query.porch = this?.deliveryInfo1?.address?.porch || '';
            this.query.floor = this?.deliveryInfo1?.address?.floor || '';
            this.query.apartment = this?.deliveryInfo1?.address?.apartment || '';
            this.query.region_id = this?.deliveryInfo1?.address?.region_id || '';
            this.query.transport_company_id = this?.deliveryInfo1?.address?.deliveryInfo1?.address || '';
            this.query.city = this?.deliveryInfo1?.address?.city || '';

            this.datePicker = this?.deliveryInfo1?.date || this.pickupDate ||  '';
            this.initInterval()
        },

        initInterval() {
            const intervals = this.getSelectInterval
            if (intervals && Array.isArray(intervals) && this.deliveryInfo1?.time) {
                const result = intervals.find((e) => e.time === this?.deliveryInfo1?.time)
                if (result) {
                    this.query.interval = result.id
                } else{
                    this.query.interval = 0
                }

            }
        },

        onChangeDate() {
            this.query.interval = ''
            this.query.pickup_date = new Date(this.datePicker)
        }
    }
}
</script>

<style scoped>
.error {
    color: red;
}
</style>